



















import { DateTime } from "luxon";
import Vue from "vue";
import { localTimezone } from "../utils";

export default Vue.extend({
  props: {
    moment: {
      type: Object as () => DateTime,
      required: true
    }
  },
  data() {
    return {
      excluding: false
    };
  },
  computed: {
    formattedTime(): string {
      return this.moment.setZone(localTimezone).toFormat("h a");
    }
  },

  methods: {
    emitExclusion() {
      this.excluding = false;
      this.$emit("exclude", this.moment);
    }
  }
});
